// extracted by mini-css-extract-plugin
export default {"divTawkIcon":"style_divTawkIcon_U3qx9","divTawk":"style_divTawk_Hq0cU"};